import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';

@NgModule({
    imports: [CommonModule, RouterModule.forRoot([]), LoginComponent],
    exports: [LoginComponent],
})
export class LoginModule {}
